import React, { useMemo } from 'react'
import { GithubPicker, ColorResult } from 'react-color'
import cx from 'classnames'
import styles from './ColorPicker.module.css'
import { Color } from '../../types/Color'

type ColorPickerProps = {
    property: string
    value: string
    onChange: (property: string, value: string) => void
    classes?: string
    children?: React.ReactNode
    colors?: string[]
    colorObjects?: Color[]
}

const ColorPicker: React.FC<ColorPickerProps> = ({
    property,
    value = '',
    onChange,
    classes,
    children,
    colors,
    colorObjects,
}) => {

    const defaultColors = [
        '#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76',
        '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3',
        '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3',
        '#D4C4FB'
    ]

    const handleColorChange = (color: ColorResult) => {
        onChange(property, color.hex)
    }

    // Find the color name from colorObjects if available
    const colorName = useMemo(() => {
        if (colorObjects && value) {
            const normalizedValue = value.toUpperCase()
            const colorObj = colorObjects.find(c => c.color.toUpperCase() === normalizedValue)
            return colorObj ? colorObj.name : undefined
        }
        return undefined
    }, [colorObjects, value])

    const hasColor = value && value.trim() !== ''

    return (
        <div className={cx(styles['color-picker-container'], classes)}>
            {children && (
                <div className={styles['color-picker-label']}>{children}</div>
            )}
            <div className={styles['selected-color-preview']}>
                {hasColor ? (
                    <>
                        <div 
                            className={styles['color-box']}
                            style={{ backgroundColor: value }}
                        />
                        <span className={styles['color-value']}>
                            {colorName || value.toUpperCase()}
                        </span>
                    </>
                ) : (
                    <span className={styles['placeholder-text']}>
                        Bitte wählen Sie eine Farbe
                    </span>
                )}
            </div>
            <div className={styles['github-picker-wrapper']}>
                <GithubPicker
                    key={property}
                    color={value || '#fff'}
                    colors={colors || defaultColors}
                    onChangeComplete={handleColorChange}
                    width={'100%'}
                />
            </div>
        </div>
    )
}

export default ColorPicker
